// Vendor
import { z } from "zod";

// Types
import type { TMembershipNames } from "../types";

export const MEMBERSHIP_OFFERS_AVAILABLE_CURRENCIES = [
  "EUR",
  "GBP",
  "USD",
] as const;

export const membershipOfferCurrencyValidator = z.enum(
  MEMBERSHIP_OFFERS_AVAILABLE_CURRENCIES,
);

export const GOODBITS_CITIZENM_SUBSCRIPTION = {
  annual: "mycitizenm+annual",
  stairStep: "mycitizenm+stairstep",
} as const;

export const membershipSubscriptionNameValidator = z.enum(
  Object.values(GOODBITS_CITIZENM_SUBSCRIPTION) as [
    TMembershipNames,
    ...TMembershipNames[],
  ],
);
